import { PrivateDocumentDto } from '@/shared/lib/sj-orm';
import { compareStrings } from '@/shared/utils/strings';

export const privateDocumentFieldSorter = {
  name: (a1: PrivateDocumentDto, a2: PrivateDocumentDto) => compareStrings(a1.name, a2.name),
  country: (a1: PrivateDocumentDto, a2: PrivateDocumentDto) =>
    compareStrings(a1.country, a2.country),
  category: (a1: PrivateDocumentDto, a2: PrivateDocumentDto) =>
    compareStrings(a1.privateCategory, a2.privateCategory),
};
